import React, { Component } from 'react'
import Venture from './venture'
import MoreButton  from '../../../../components/Buttons/plus'
import LessButton from '../../../../components/Buttons/less'
import { Link, browserHistory } from 'react-router';
import { Button, Col } from 'react-bootstrap'
import { translate } from "react-translate"
import { pick, paramsForProperties } from '../../../../actions/api'

@translate("ListVentures")
export default class ListVentures extends Component {

  constructor (props) {
    super(props)
    this.state = {
      viewMore: false
    }
    this.handleMoreElements = this.handleMoreElements.bind(this)
  }

  handleMoreElements(event,pl) {
    this.setState({viewMore: !this.state.viewMore});
    this.props.loadVentures(pl)
  }

  handleClick(e,id){
    e.preventDefault();
    this.props.loadVenturesById(id);
  }

  render () {

    const { list, current, last, total, loadVenturesById, loadVentures, t} = this.props

    return (
    	<div className="container">
        <Col xs={12} md={12}>
          {list.map((item, index) =>
            <Link to="/propiedades" onClick={(e) => this.handleClick(e, item.property_code)} key={index}>
              <Col xs={12} md={6} className="col-barrio">
                <Venture item={item} />
              </Col>
            </Link>
          )}
        </Col>
        { (current === last) ? '' : (
          <div className={"btn-more-container hidden-xs" + (this.state.viewMore ? ' hide-button' : '')}>
            <MoreButton onClickMore={(e) => this.handleMoreElements(e,total)} />
          </div> )
        }
        <div className={"btn-more-container visible-xs" + (this.state.viewMore ? ' hide-button' : '')}>
          <Button bsStyle="link" className="visible-xs" onClick={(e) => this.handleMoreElements(e,total)}>
            {t("Ver_Mas")}
          </Button>
        </div>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageEntrepreneurship/components/List/index.js